export const ONLY_NUMBER_REGEX = /^[0-9]$/;
export const FISCAL_CODE_REGEX = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/;
